__turbopack_context__.v({
  "className": "inter_213f4dbe-module__h8Uipa__className",
  "variable": "inter_213f4dbe-module__h8Uipa__variable",
});
